import axios from "axios";
import { BASE_SERVER_URL } from "../envVar";

axios.defaults.baseURL = `${BASE_SERVER_URL}`;
axios.defaults.timeout = 500000;

export default axios;
